import Carousel from "@Components/Carousel";
import styles from "../PropertyDetailsSectionStyles.module.scss";
import FactsScroll from "./FactsScroll";
import useIsDesktop from "hooks/useIsDesktop";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import useCountry from "hooks/useCountry";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";
import useIsLanguage from "hooks/useIsLanguage";
//

const MetaFacts = ({ isLoading, metaCommunityFacts, metaGeneralFacts, fromProperty }: any) => {
  const country = useCountry("IN");
  const { t } = useTranslationHook();
  const isDesktop = useIsDesktop();
  const nameArray: any = [];
  const getMetaFacts: any = () => {
    let metaFactsTemp: any = [];
    if (country == "IN") {
      const country_meta_facts = metaCommunityFacts?.[country] ?? [];
      country_meta_facts?.forEach((cmf: any) => {
        if (cmf?.name) {
          nameArray.push(cmf.name);
          let value: any = <></>;
          switch (cmf.name) {
            case "bookings_in_90days":
              value = (
                <>
                  {cmf["count"]}
                  <b>
                    {" "}
                    {t("propertypage.components.propertydetailssection.indianstudent")}
                    {cmf["count"] > 1 ? "s" : ""}
                  </b>{" "}
                  {t("propertypage.components.propertydetailssection.bookedthispropertyrecently")}
                </>
              );
              break;
            case "enquires_in_30days":
              value = (
                <>
                  {cmf["count"]}
                  <b>
                    {" "}
                    {t("propertypage.components.propertydetailssection.indianstudent")}
                    {cmf["count"] > 1 ? "s" : ""}
                  </b>{" "}
                  {t(
                    "propertypage.components.propertydetailssection.enquiredforthispropertyrecently",
                  )}
                </>
              );
              break;
            case "previous_year_booking":
              value = (
                <>
                  {cmf["count"]}
                  <b>
                    {" "}
                    {t("propertypage.components.propertydetailssection.indianstudent")}
                    {cmf["count"] > 1 ? "s" : ""}
                  </b>{" "}
                  {t("propertypage.components.propertydetailssection.bookedthispropertylastyear")}
                </>
              );
              break;
            default:
              value = "";
              break;
          }

          metaFactsTemp = [...metaFactsTemp, ...[{ ...cmf, value }]];
        }
      });
      if (nameArray.includes("bookings_in_90days")) {
        metaFactsTemp = metaFactsTemp?.filter((cmf: any) => cmf.name == "bookings_in_90days");
      } else if (nameArray.includes("enquires_in_30days")) {
        metaFactsTemp = metaFactsTemp?.filter((cmf: any) => cmf.name == "enquires_in_30days");
      } else if (nameArray.includes("previous_year_booking")) {
        metaFactsTemp = metaFactsTemp?.filter((cmf: any) => cmf.name == "previous_year_booking");
      }
    }

    function moveObjectToFront(arr: any, key: any, value: any) {
      // Find the index of the object with the specific value for the key
      const index = arr.findIndex((obj: any) => obj[key] === value);

      if (index === -1) {
        // Object not found, return the original array
        return arr;
      }

      // Remove the object from its current position
      const [objectToMove] = arr.splice(index, 1);

      // Insert the object at the beginning of the array
      arr.unshift(objectToMove);

      return arr;
    }

    let sortedMetaGeneralFacts = [...metaGeneralFacts].sort((a: any, b: any) => b.count - a.count);
    sortedMetaGeneralFacts = moveObjectToFront(sortedMetaGeneralFacts, "name", "recent_booking");

    if (
      metaFactsTemp[0]?.name == "bookings_in_90days" ||
      metaFactsTemp[0]?.name == "previous_year_booking"
    ) {
      sortedMetaGeneralFacts.forEach((smgf: any) => {
        if (metaFactsTemp.length == 2) return;
        if (smgf.name !== "recent_booking") {
          metaFactsTemp.push(smgf);
        }
      });
    } else if (metaFactsTemp[0]?.name == "enquires_in_30days") {
      sortedMetaGeneralFacts.forEach((smgf: any) => {
        if (metaFactsTemp.length == 2) return;
        if (smgf.name !== "enquires_in_15days") {
          metaFactsTemp.push(smgf);
        }
      });
    } else {
      metaFactsTemp = sortedMetaGeneralFacts.slice(0, 2);
    }
    return metaFactsTemp || [];
  };

  const metaFacts = getMetaFacts();
  const language = useIsLanguage();

  return !isLoading && language === "en" && metaFacts?.length > 0 ? (
    <Carousel
      className={formatClassNames(
        styles.carouselContainer,
        isDesktop ? styles.desktopcarouselcontainer : "",
      )}
      slideList={metaFacts?.map((fact: any, idx: any) => (
        <FactsScroll data={fact} key={idx} isDesktop={isDesktop} fromProperty={fromProperty} />
      ))}
      activePos={1}
      autoSlide={metaFacts.length > 1}
    />
  ) : (
    <></>
  );
};

export default wrapperHOC(MetaFacts, {
  componentName: "MetaFacts-PropertyDetailsSection-PropertyPage",
  showForChina: true,
});
